// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@5.2.7_webpack@4.41.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bagdetail .ti-item,.bagdetail .ti-tag{color:#000!important}.bagdetail .ti-item.ti-selected-item,.bagdetail .ti-tag.ti-selected-item{border:1px solid #000}.bagdetail .ti-item{border:1px solid transparent}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
